var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-wrapper"},[(_vm.isDisplay)?_c('table',{staticClass:"table"},[_vm._t("default")],2):_vm._e(),_c('div',{staticClass:"btn-wrapper"},[_c('button',{staticClass:"btn",class:{ 'btn-default': _vm.isDisplay },on:{"click":_vm.toggleVisible}},[_vm._v(" "+_vm._s(_vm.label)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }